<template>
  <el-form
    inline
    label-width="120px"
    label-position="right"
    label-suffix="："
  >
    <page-block title="基本信息" name="货主详情">
      <el-form-item label="货主类型">
        <span>企业</span>
      </el-form-item>
      <el-row>
        <el-col :span="10">
          <el-form-item label="企业简称">
            <span>{{ form.customerName ? form.customerName : form.corpName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="社会信用代码">
            <span>{{ form.uniformCreditCode }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="企业名称">
            <span>{{ form.corpName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="货主编码">
            <span>{{ form.customerCode }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="联系人姓名">
            <span>{{ form.contacts }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="联系人手机">
            <span>{{ form.telPhone }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="联系地址">
            <span>{{ form.provinceName || '' }}{{ form.cityName || '' }}{{ form.countyName || '' }}{{ form.address || '' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="产品">
            <span>{{ productVal }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="营业执照">
            <el-image
              v-if="form.ext && form.ext.businessLicenseUrl"
              fit="contain"
              class="cover-image"
              :src="form.ext.businessLicenseUrl"
              :preview-src-list="[form.ext.businessLicenseUrl]"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户行业类型">
            <span>{{ form.industryType }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="所属赛道">
            <span>{{ getTrackLabel(form.businessTrack) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="business-owner-item" label="商务负责人">
            <div class="business-owner-value">
              {{ getBusinessOwnerLabel(form.businessOwnerList) }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </page-block>
    <page-block
      v-for="(item,index) in form.crmCustomerInvoices"
      :key="index"
      :title="form.crmCustomerInvoices.length>1?'开票信息'+(index+1):'开票信息'"
    >
      <div
        class="list-item"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="名称">
              <span>{{ item.invoice }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="纳税人识别号">
              <span>{{ item.taxpayerNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="单位地址">
              <span>{{ item.invoiceAddress }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="电话号码">
              <span>{{ item.invoiceTelPhone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户银行">
              <span>{{ item.bank }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账号">
              <span>{{ item.account }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </page-block>
    <page-block title="组织结构">
      <div v-if="bindType === BINDTYPE.PARENT">
        <el-row>
          <el-col>
            <el-form-item label="绑定类型">
              <span>绑定上级</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="上级">
              <span>{{ parent.name }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-else-if="bindType === BINDTYPE.CHILDREN">
        <el-row>
          <el-col>
            <el-form-item label="绑定类型">
              <span>绑定下级</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="下级">
              <el-table
                :data="levelList"
                border
              >
                <el-table-column
                  align="center"
                  type="index"
                  label="序号"
                  fixed
                  width="50"
                />
                <el-table-column
                  v-for="item in TABLECOLUMN"
                  :key="item.prop"
                  :type="item.type"
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width"
                >
                  <template slot-scope="scope">
                    <span
                      v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row v-else>
        <el-col>
          <el-form-item label="绑定类型">
            <span>不绑定</span>
          </el-form-item>
        </el-col>
      </el-row>
    </page-block>
  </el-form>
</template>

<script>
import PageBlock from '@/components/PageBlock/index.vue';
import { getChildrenPage } from '@/api/shipper';
import { getDictionary } from '@/api/crm/crmCustomer';
import {
  TABLECOLUMN, BINDTYPE, TYPE,
} from '../constant';
import { dictionaryType, TRACK_LIST } from '../../shipperCreate/constant';

export default {
  components: {
    PageBlock,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      TABLECOLUMN,
      BINDTYPE,
      levelList: [],
      productList: [],
      parent: {},
      bindType: '',
    };
  },
  computed: {
    productVal() {
      return this.productList.filter((item) => item.dictionaryCode === this.form.ext.productCode)[0]?.dictionaryName || '无';
    },
  },
  async created() {
    this.productList = await this.getDictionary(dictionaryType.crmProductRange);
    getChildrenPage({
      identityIds: [this.form.id],
      type: TYPE,
      needCustomerInfo: true,
      needRelation: true,
    },
    {
      page: 1,
      size: 200,
    }).then((res) => {
      const records = res.records[0] || {};
      if (records.parentOrg) {
        this.bindType = this.BINDTYPE.PARENT;
        this.parent = records.parentOrg;
      } else if (records.childrenOrg && records.childrenOrg.length) {
        this.bindType = this.BINDTYPE.CHILDREN;
        this.levelList = records.childrenOrg;
      } else {
        this.bindType = 'NONE';
      }
    });
  },
  methods: {
    getTrackLabel(track) {
      return track ? track.split(',').map((item) => TRACK_LIST.find((t) => t.value === item)?.label).join('、') : '--';
    },
    getBusinessOwnerLabel(businessOwnerList) {
      return businessOwnerList && businessOwnerList.length ? businessOwnerList.map((item) => item.businessOwnerName).join('、') : '--';
    },
    async getDictionary(type) {
      const res = await getDictionary({
        status: 1,
        type,
      });
      return res || [];
    },
  },
};
</script>

<style scoped>
.cover-image {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #999999;
}
.business-owner-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
